export default __webpack_public_path__ + "4ec0c5b01adf6bf89632a7782cd5c1ca.png";